import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {requireImage} from '../../utils/utils';
import './ts-sharing-mode.scss';
import {ISharingModeActions} from '../../services/ts-sharing-service/contracts';

interface TsSharingModeProps {
    actions: ISharingModeActions[];
    displayMode?: string;
    data: any;
    isResourceReady: boolean;
    onShareClick: (e: React.MouseEvent, data: any) => void;
    onShareActionClick: (e: React.MouseEvent, type: string, data: any) => void;
}

@observer
export class TsSharingMode extends TechseeBaseComponent<TsSharingModeProps> {
    constructor(props: TsSharingModeProps) {
        super(props);
    }

    renderInternal(): JSX.Element {
        const {actions, displayMode, data, isResourceReady, onShareClick, onShareActionClick} = this.props;

        if (!actions) {
            return <></>;
        }

        const shareAction = actions.find((action) => action.type === 'share');
        const enabledActions = actions.filter((action) => action.enable && action.type !== 'share');

        return (
            <div className={`ts-sharing-mode ${displayMode} ${isResourceReady ? 'is-open' : ''}`}>
                {isResourceReady && (
                    <div className='options-wrapper'>
                        {enabledActions.map((actionItem, index) => (
                            <a
                                key={index}
                                onClick={(e) => {
                                    onShareActionClick(e, actionItem.type, data);
                                }}>
                                <img
                                    src={requireImage(
                                        isResourceReady ? actionItem.icons.enable : actionItem.icons.disable
                                    )}
                                    alt={actionItem.alt}
                                />
                            </a>
                        ))}
                    </div>
                )}
                {shareAction && (
                    <a className='share-toggle' onClick={(e) => onShareClick(e, data)}>
                        <img src={requireImage(shareAction.icons.enable)} alt={shareAction.alt} />
                    </a>
                )}
            </div>
        );
    }
}

export default TsSharingMode;
